import { baseUrlEndpoint, baseUrlPattern, resolveBaseUrl } from "../baseUrl";
import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { geminiUsage } from "./usage";

const DEFAULT_GEMINI_BASE_URL =
  "https://generativelanguage.googleapis.com/v1beta";

export const googleGemini = defineConnector({
  identifier: "googleGemini",
  name: "Google Gemini",
  tagLine: "Multimodal AI platform",
  logo,
  protocol: "http",
  tags: ["featured", "ai", "engineering"],
  defaultUrlPattern: ({ baseUrl }) =>
    baseUrlPattern(baseUrl, DEFAULT_GEMINI_BASE_URL),
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Google AI Studio](https://aistudio.google.com/apikey) and create or copy an API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Google Gemini API key",
          placeholder: "AIza...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "url",
          label: "Base URL (optional)",
          placeholder: DEFAULT_GEMINI_BASE_URL,
          defaultValue: DEFAULT_GEMINI_BASE_URL,
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Leave blank for the default Gemini API endpoint.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) =>
      baseUrlEndpoint(baseUrl, DEFAULT_GEMINI_BASE_URL, "/models"),
  },
  publicEnvVars: ({ baseUrl }) => ({
    GOOGLE_GEMINI_BASE_URL: resolveBaseUrl(baseUrl, DEFAULT_GEMINI_BASE_URL),
  }),
  usageHint: () =>
    "Use process.env.GOOGLE_GEMINI_BASE_URL as the Gemini API base URL. Pass a placeholder API key; the proxy injects the real key from the connected app.",
  usage: geminiUsage(),
});
